module.exports = __webpack_public_path__ + "img/history_icon.304fedc1.svg";